import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { href: '#home', label: 'Work' },
    { href: '#about', label: 'About' },
    { href: '#resume', label: 'Resume' },
    { href: '#contact', label: 'Contact' },
  ];

  const scrollToSection = (e, id) => {
    e.preventDefault();
    setIsOpen(false);
    window.setTimeout(() => {
      document.querySelector(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[rgba(11,10,9,0.72)] border-b border-[var(--line)]">
      <div className="wrap flex items-center justify-between py-4">
        <Link to="/" className="no-underline text-[var(--ink)] flex items-baseline gap-1">
          <span className="t-display text-[28px] leading-none">Karan</span>
          <span className="text-[var(--signal)] text-3xl leading-none">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => scrollToSection(e, item.href)}
              className="text-sm text-[var(--muted)] hover:text-[var(--ink)] no-underline"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <span className="chip">
            <span className="pulse-dot" />
            Available
          </span>
          <a
            href="https://freelysta.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost !py-2 !px-4"
          >
            Freelysta
          </a>
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden bg-transparent border-0 text-[var(--ink)] text-sm"
          aria-label="Menu"
        >
          {isOpen ? 'Close' : 'Menu'}
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden border-t border-[var(--line)] bg-[var(--bg)]">
          <div className="wrap py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className="text-[var(--ink)] no-underline text-lg"
              >
                {item.label}
              </a>
            ))}
            <a href="https://freelysta.com" target="_blank" rel="noopener noreferrer" className="t-signal no-underline">
              Freelysta
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
